import { createdBoxQueries } from '@/entities/sets/created';
import useToggle from '@/shared/hooks/useVisible';
import { Pagination } from '@/shared/ui/pagination/pagination';
import { findColor } from '@/shared/utils/publish';
import * as Dialog from '@radix-ui/react-dialog';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { usePersistStore } from '@/shared/lib/store';

interface GroupedByVersion {
    [version: number]: DATA.ExamHist[]; // number 키 => 배열
}

const yearArr = [
    {
        value: 'all',
        label: '전체',
    },
    // {
    //     value: '2024',
    //     label: '2024학년도',
    // },
    {
        value: '2025',
        label: '2025학년도',
    },
    {
        value: '2026',
        label: '2026학년도',
    },
];

export const PublishedHistoryPopup = ({ examId }: { examId: number }) => {
    const queryClient = useQueryClient();
    const { sMyClassMemberList, sUserId } = usePersistStore();
    const [historyList, setHistoryList] = useState<{ version: number; items: DATA.ExamHist[] }[]>(
        []
    );
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [selectDate, setSelectDate] = useState({
        value: '2026',
        label: '2026학년도',
    });
    const [selectOpen, setSelectOpen] = useToggle();

    const { data, refetch } = createdBoxQueries.getCreatedBoxPublishedHistory({
        wrterId: sUserId,
        examId: examId,
        dateFrom: selectDate.value === 'all' ? '' : selectDate.value + '.1.1',
        dateTo: selectDate.value === 'all' ? '' : selectDate.value + '.12.31',
        page: page,
        size: 10,
    });

    useEffect(() => {
        if (data) {
            setTotalPage(data.page.totalPages);

            const sorted = data?.examHist.sort((a, b) => b.version - a.version);

            const groupedObj = sorted.reduce((acc, item) => {
                const ver = item.version;
                if (!acc[ver]) {
                    acc[ver] = [];
                }
                acc[ver].push(item);
                return acc;
            }, {} as GroupedByVersion);

            const groupedArr = Object.entries(groupedObj).map(([versionStr, items]) => ({
                version: Number(versionStr),
                items,
            }));

            const versionSorted = groupedArr.sort((a, b) => b.version - a.version);

            setHistoryList(versionSorted);
        }
    }, [data]);

    useEffect(() => {
        return () => queryClient.removeQueries({ queryKey: ['history', 'created-box'] });
    }, []);

    const findClassNm = (claId: string) => {
        const classSeq = claId.split('-')[4];
        const findClass = sMyClassMemberList?.find(
            (item) => item.classInfo.classSeq === Number(classSeq)
        );
        return findClass?.classInfo.clsName;
    };

    return (
        <div className="pop_wrap publish_table_pop">
            <div className="modal_header">
                <div className="title">발행 이력</div>
            </div>
            <div className="pop_contents publish_table_popcont">
                <div className="base-box box-type">
                    <div className="flex_b tableInfo">
                        <p className="info">
                            * 자료를 발행한 이력을 최신순으로 확인할 수 있습니다.
                        </p>
                        <div className="dropdown-wrap">
                            <div className="dropdown-box">
                                <div className={`dropdown-btn ${selectOpen && 'isOpen'}`}>
                                    <button type="button" onClick={setSelectOpen}>
                                        {selectDate ? selectDate.label : '년도를 선택 해주세요.'}
                                    </button>
                                </div>
                                <div className={`dropdown-content ${selectOpen && 'isOpen'}`}>
                                    <div className="option-type-default">
                                        {yearArr.map((item, idx) => (
                                            <div
                                                key={`publish-history-${idx}`}
                                                className={`option ${selectDate.value === item.value && 'isCurrent'}`}
                                            >
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setSelectOpen();
                                                        setSelectDate(item);
                                                    }}
                                                >
                                                    {item.label}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="pop_table publish_table">
                        <colgroup>
                            <col width="70px" />
                            <col width="90px" />
                            <col width="*" />
                            <col width="160px" />
                            <col width="160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>버전</th>
                                <th>구분</th>
                                <th>발행 제목</th>
                                <th>발행 클래스</th>
                                <th>발행일시</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historyList && historyList.length > 0 ? (
                                historyList.map((e, i) => {
                                    return (
                                        <>
                                            {e.items.map((el, il) => (
                                                <tr key={`pub-history-${il}`}>
                                                    <td className="version">
                                                        {/* <Tooltip.Provider>
                                                            <Tooltip.Root>
                                                                <Tooltip.Trigger> */}
                                                        <span className="textCloud-wrap use-version">
                                                            <span>Ver {e.version}</span>
                                                            <span className="textCloud type3">
                                                                {el?.examRegDt}{' '}
                                                                {e.version !== 1 ? '수정' : '생성'}
                                                            </span>
                                                        </span>
                                                        {/* <button className="btn btn-icon">
                                                                        <span className={'tooltip'}>
                                                                            툴팁 확인
                                                                        </span>
                                                                        Ver {e.version}{' '}
                                                                    </button> */}
                                                        {/* </Tooltip.Trigger>
                                                            </Tooltip.Root>
                                                        </Tooltip.Provider> */}
                                                    </td>

                                                    <td className="division">
                                                        {/* 출력용 orange 클래스 */}
                                                        <span
                                                            className={`${findColor(el.publishUse)}`}
                                                        >
                                                            {el.publishUse}
                                                        </span>
                                                    </td>
                                                    <td className="title">
                                                        <a
                                                            href={`/sets/published-box/detail/${el.publishId}`}
                                                        >
                                                            {el.publishNm}
                                                        </a>
                                                    </td>
                                                    <td className="class">
                                                        {findClassNm(el.claId)
                                                            ? findClassNm(el.claId)
                                                            : '-'}
                                                    </td>
                                                    <td className="date">
                                                        {el.publishRegDt ?? '-'}
                                                    </td>
                                                </tr>
                                            ))}
                                            {/* 버전 관리 */}
                                            {/* <tr>
                                                <td colSpan={5} className="ver_history">
                                                    {e.version === 1
                                                        ? '최초 생성'
                                                        : `Ver ${e.version} 수정 `}{' '}
                                                    <span className="date">
                                                        (
                                                        {e.items?.length > 0 &&
                                                            e.items[e.items.length - 1].regDt}
                                                        )
                                                    </span>
                                                </td>
                                            </tr> */}
                                        </>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan={5}
                                        style={{
                                            width: '100%',
                                            height: '400px',
                                            textAlign: 'center',
                                            verticalAlign: 'middle',
                                            fontSize: '18px',
                                            color: '#999',
                                        }}
                                    >
                                        발행 이력이 없습니다.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="board-footer">
                        <Pagination
                            currentPage={page}
                            totalPages={totalPage}
                            onChange={(page: number) => setPage(page)}
                            pageBtnCount={5}
                        />
                    </div>
                </div>
            </div>
            <Dialog.Close asChild>
                <button type="button" className="btn-x btn-x-white">
                    <span className="sr-only">팝업 닫기</span>
                </button>
            </Dialog.Close>
        </div>
    );
};
